module.exports = __webpack_public_path__ + "static/CalypsoScreenshoot-965e0cecd965b0ea80ebaf5b86cadd39.png";